import { render } from "./TheTicketSecondaryTitle.vue?vue&type=template&id=3a6d4cb6"
import script from "./TheTicketSecondaryTitle.vue?vue&type=script&lang=js"
export * from "./TheTicketSecondaryTitle.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "3a6d4cb6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a6d4cb6', script)) {
    api.reload('3a6d4cb6', script)
  }
  
  module.hot.accept("./TheTicketSecondaryTitle.vue?vue&type=template&id=3a6d4cb6", () => {
    api.rerender('3a6d4cb6', render)
  })

}

script.__file = "src/views/support/pageTitles/TheTicketSecondaryTitle.vue"

export default script